<template>
    <pendo-icon-button
        id="expand-collapse-nav-button"
        v-pendo-tooltip="{
            content: expandCollapseTooltipText,
            placement: 'bottom',
            arrow: true,
        }"
        :class="{
            'nav-option': !isTopNav,
            'top-nav__trigger': isTopNav,
            'top-nav__button-trigger': isTopNav,
        }"
        data-cy="expand-collapse-icon"
        pendo-analytics="collapse-nav-item"
        icon="menu"
        icon-size="16"
        type="tertiary"
        size="small"
        :aria-label="expandCollapseTooltipText"
        @click="handleClick"
        @keydown.enter.prevent="handleKeyDown"
        @keydown.space.prevent="handleKeyDown" />
</template>

<script>
import { PendoIconButton, PendoTooltip } from '@pendo/components-vue3';
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia';
import { useLeftNavStore } from '@/stores/left-nav.store';

export default {
    components: {
        PendoIconButton,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        isTopNav: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapPiniaState(useLeftNavStore, ['expanded']),
        expandCollapseTooltipText () {
            return this.expanded ? this.$t('sideNav.Collapse side navigation') : this.$t('sideNav.Expand side navigation');
        },
    },
    methods: {
        ...mapPiniaActions(useLeftNavStore, ['expandCollapseNav']),
        handleClick ($event) {
            if ($event.detail === 0) {
                return;
            }

            this.expandCollapseNav({ expanded: !this.expanded });
        },
        handleKeyDown () {
            this.expandCollapseNav({ expanded: !this.expanded });
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';

#expand-collapse-nav-button {
    &.nav-option {
        margin: 0;
        padding: 2px;
        min-width: unset;
        border-radius: 5px;
        height: 30px;
        width: 30px;
        border: none;

        &:focus-visible {
            outline: 2px solid var(--focus-ring-base);
            outline-offset: -2px;
        }

        &:hover {
            background-color: var(--surface-secondary-hover);
        }
    }

    &.top-nav__trigger {
        min-width: unset;
    }
}
</style>